module.exports = __webpack_public_path__ + "static/media/Niveau_elN13_3_316512.b6d13b0b.png";